import { useState, useEffect } from 'react';

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const checkIfMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
      const mobileWidth = 768;

      // Check if user agent matches common mobile device keywords
      const isMobileDevice = /android|iphone|ipad|ipod|opera mini|iemobile|blackberry|mobile/i.test(userAgent);
      // Check if window width is below typical mobile screen width
      const isMobileScreen = window.innerWidth < mobileWidth;

      setIsMobile(isMobileDevice || isMobileScreen);
    };

    // Initial check on component mount
    checkIfMobile();

    // Add resize event listener to update on window resize
    window.addEventListener('resize', checkIfMobile);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  return isMobile;
};
